const rateMapper = (appliedFilter) => {
  return {
    booleanFilters: [
      {
        column: 'HasRate',
        value: appliedFilter.criterionArgumentValue,
      },
    ],
  };
};

export default rateMapper;
